<footer class="footer-container">
  <!-- Top Decorative Line -->
  <div class="footer-top-line"></div>

  <div class="footer-content">
    <!-- Main Footer Grid -->
    <div class="footer-grid">
      <!-- Branding Section -->
      <div class="footer-section footer-branding">
        <div class="footer-logo">
          <p class="footer-brand-name">Chase Your Sport</p>
        </div>
        <p class="footer-tagline">
          Stay up-to-date on the latest sports news, stats, expert analysis and
          trends, including cricket, football, wrestling, tennis, basketball,
          Formula One and more.
        </p>
        <div class="social-links">
          <a href="https://www.facebook.com/SportsSocialBlog" target="_blank" class="social-icon" pTooltip="Follow on Facebook">
            <i class="pi pi-facebook"></i>
          </a>
          <a href="https://twitter.com/chaseyoursport" target="_blank" class="social-icon" pTooltip="Follow on Twitter">
            <i class="pi pi-twitter"></i>
          </a>
          <a href="https://www.instagram.com/chaseyoursport/" target="_blank" class="social-icon" pTooltip="Follow on Instagram">
            <i class="pi pi-instagram"></i>
          </a>
          <a href="https://in.pinterest.com/chaseyoursport1" target="_blank" class="social-icon" pTooltip="Follow on Pinterest">
            <i class="fa-brands fa-pinterest"></i>
          </a>
        </div>
      </div>

      <!-- Quick Links -->
      <div class="footer-section">
        <h3 class="footer-section-title">Quick Links</h3>
        <ul class="footer-links">
          <li><a href="/about" class="footer-link">About Us</a></li>
          <li><a href="/advertise" class="footer-link">Advertise</a></li>
          <li><a href="/contact" class="footer-link">Contact Us</a></li>
          <li><a href="/topic/explore-topics" class="footer-link">Explore Topics</a></li>
        </ul>
      </div>

      <!-- Legal -->
      <div class="footer-section">
        <h3 class="footer-section-title">Legal</h3>
        <ul class="footer-links">
          <li><a href="/privacy-policy" class="footer-link">Privacy Policy</a></li>
          <li><a href="/terms-of-service" class="footer-link">Terms of Service</a></li>
          <li><a href="/cookie-policy" class="footer-link">Cookie Policy</a></li>
        </ul>
      </div>

      <!-- Newsletter -->
      <div class="footer-section footer-newsletter">
        <h3 class="footer-section-title">Newsletter</h3>
        <p class="newsletter-text">Get the latest sports updates delivered to your inbox</p>
        <form [formGroup]="newsletterForm" (ngSubmit)="onNewsletterSubmit()" class="newsletter-form">
          <div class="newsletter-field">
            <input
              type="text"
              placeholder="Your name"
              formControlName="name"
              class="newsletter-input"
            />
            <span class="error-message" *ngIf="newsletterForm.get('name')?.touched && newsletterForm.get('name')?.errors?.['required']">
              <i class="pi pi-exclamation-circle"></i> Name is required
            </span>
          </div>

          <div class="newsletter-input-wrapper">
            <input
              type="email"
              placeholder="Your email"
              formControlName="email"
              class="newsletter-input"
            />
            <button
              type="submit"
              class="newsletter-btn"
              [disabled]="isSubmitting"
            >
              <i class="pi" [ngClass]="isSubmitting ? 'pi-spin pi-spinner' : 'pi-send'"></i>
            </button>
          </div>
          <span class="error-message" *ngIf="newsletterForm.get('email')?.touched && newsletterForm.get('email')?.errors?.['required']">
            <i class="pi pi-exclamation-circle"></i> Email is required
          </span>
          <span class="error-message" *ngIf="newsletterForm.get('email')?.touched && newsletterForm.get('email')?.errors?.['email']">
            <i class="pi pi-exclamation-circle"></i> Please enter a valid email
          </span>
        </form>
      </div>
    </div>

    <!-- Divider -->
    <div class="footer-divider"></div>

    <!-- Bottom Footer -->
    <div class="footer-bottom">
      <p class="copyright-text">&copy; 2026 Chase Your Sport. All rights reserved.</p>
      <p class="footer-tagline-small">Sports journalism at its finest.</p>
    </div>
  </div>
</footer>

<p-toast></p-toast>


